import OlVectorSource from 'ol/source/Vector';
import OlVectorLayer from 'ol/layer/Vector';
import { NEDGLOBE_VIEWER } from '../../../constants';

export function createCustomLayers(map) {
    let layerIndex = 0;
    // these layers will be added to the printable map
    const printableLayers = Object.values(NEDGLOBE_VIEWER.customLayers.printable).reduce((acc, value) => {
        layerIndex++;
        acc[value] = createCustomLayer(undefined, value, NEDGLOBE_VIEWER.customLayersIndexes.start + layerIndex);
        map.addLayer(acc[value]);
        return acc;
    }, {});
    const displayOnlyLayers = Object.values(NEDGLOBE_VIEWER.customLayers.displayOnly).reduce((acc, value) => {
        layerIndex++;
        // adds map as parameter, this sets the layer as overlay on a map.
        // The map will not manage this layer in its layers collection, and the layer will be rendered on top.
        acc[value] = createCustomLayer(map, value, NEDGLOBE_VIEWER.customLayersIndexes.start + layerIndex);
        return acc;
    }, {});
    return { ...printableLayers, ...displayOnlyLayers };
}

export function createCustomLayer(map, title = 'customLayer', zIndex = NEDGLOBE_VIEWER.customLayersIndexes.default) {
    // declutter is used to avoid overlapping labels/images
    return new OlVectorLayer({ map, title, visible: true, source: new OlVectorSource({}), zIndex, declutter: true });
}
